import axios from "axios";
import React, { useEffect, useState, FormEvent } from "react";
import Aside from "../../components/Aside/Aside";
import { Profile } from "../../types";

import Notification from "../../components/Alert/notification";
import classNames from "classnames";
import { Navigate } from "react-router-dom";

interface ProfileProps {}

const ProfilePage: React.FC<ProfileProps> = () => {
  const [profile, setProfile] = useState<Profile>();

  const [email, setEmail] = useState(profile?.email);
  const [password, setPassword] = useState("");

  const [phone, setPhone] = useState(profile?.phone);
  const [notification, setNotification] = useState(true);

  const [isCheckedSms, setIsCheckedSms] = useState(false);
  const [isCheckedEmail, setIsCheckedEmail] = useState(false);

  useEffect(() => {
    async function fetchNotification() {
      const { data: profile } = await axios.get("v1/profile/info");
      setProfile(profile);
      await axios
        .post("v1/notification/state", {
          username: `${profile!.username}`,
        })
        .then((res) => {
          setIsCheckedEmail(JSON.parse(res.data.email));
          setIsCheckedSms(JSON.parse(res.data.sms));
        });
    }
    fetchNotification();
  }, []);

  if (profile?.tariffName === "Стартовый Ямал") return <Navigate to="/inet/activate" />;

  const editProfile = async (event: FormEvent) => {
    event.preventDefault();

    if (password.trim() === "") return;

    try {
      axios
        .post("v1/profile/edit ", {
          email: `${!email ? profile!.email : email}`,
          full_name: `${profile?.fullName}`,
          mobile_telephone: `${!phone ? profile!.phone : phone}`,
          password: `${password}`,
        })
        .then(({ data }) => {
          setProfile({
            id: profile!.id,
            balance: profile!.balance,
            basicAccount: profile!.basicAccount,
            credit: profile!.credit,
            email: !email ? profile!.email : email,
            fullName: profile!.fullName,
            groupID: profile!.groupID,
            isActive: profile!.isActive,
            isBlocked: profile!.isBlocked,
            BlockedType: profile!.BlockedType,
            isJuridical: profile!.isJuridical,
            paymentInMonth: profile!.paymentInMonth,
            phone: !phone ? profile!.phone : phone,
            tariffLinkID: profile!.tariffLinkID,
            tariffName: profile!.tariffName,
            username: profile!.username,
            taxNumber: profile!.taxNumber,
            contractID: profile!.contractID,
            IP: false
          });
        });
      setPassword("");
      setPhone("");
      setEmail("");
      setNotification(true);
      setTimeout(() => {
        setNotification(false);
      }, 5000);
    } catch (err) {
      console.log(err);
    }
  };

  const checkNotificationSms = async () => {
    try {
      await axios
        .post("v1/notification/check", {
          username: profile!.username,
          sms: `${!isCheckedSms}`,
        })
        .then((res) => setIsCheckedSms(JSON.parse(res.data.sms)));
    } catch (err) {
      console.log(err);
    }
  };

  const checkNotificationEmail = async () => {
    try {
      await axios
        .post("v1/notification/check", {
          username: profile!.username,
          email: `${!isCheckedEmail}`,
        })
        .then((res) => setIsCheckedEmail(JSON.parse(res.data.email)));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside isJurical={profile?.isJuridical} />

      <div style={{ width: "100%" }}>
        <main data-v-dde546dc="" className="el-main">
          <div data-v-0c054ff4="" data-v-dde546dc="" className="profile">
            <h1 data-v-0c054ff4="">Аккаунт</h1>
            <div data-v-0c054ff4="">
              <div
                data-v-0c054ff4=""
                className="profile__cards gutters el-row el-row--flex"
              >
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8"
                >
                  <div
                    data-v-0c054ff4=""
                    className="el-card py16 is-always-shadow card--warning"
                  >
                    <div className="el-card__header">
                      <div data-v-0c054ff4="">
                        <i
                          data-v-0c054ff4=""
                          aria-hidden="true"
                          className="fa fa-mobile-alt card__icon"
                        ></i>
                        <div
                          data-v-0c054ff4=""
                          className="flex align-center justify-between"
                        >
                          <small data-v-0c054ff4="">Мобильный телефон</small>
                          <span data-v-0c054ff4="" className="popover-editor">
                            <div
                              role="tooltip"
                              id="el-popover-9430"
                              aria-hidden="true"
                              className="el-popover el-popper"
                              tabIndex={0}
                              style={{ width: 250, display: "none" }}
                            ></div>
                            <button
                              type="button"
                              className="el-button el-tooltip el-button--default el-button--mini is-circle el-popover__reference"
                              aria-describedby="el-popover-9430"
                              tabIndex={0}
                            >
                              <i className="el-icon-edit"></i>
                            </button>
                          </span>
                        </div>
                        <h3 data-v-0c054ff4="" className="editor-content">
                          {profile?.phone ? profile?.phone : "не указан"}
                        </h3>
                      </div>
                    </div>
                    <div className="el-card__body">
                      <div data-v-0c054ff4="" className="flex align-center">
                        <div
                          data-v-0c054ff4=""
                          className={classNames(
                            isCheckedSms ? "el-switch is-checked" : "el-switch "
                          )}
                          onClick={checkNotificationSms}
                        >
                          <input type="checkbox" className="el-switch__input" />
                          {isCheckedSms ? (
                            <span
                              className="el-switch__core"
                              style={{
                                width: 40,
                                borderColor: "rgb(80, 167, 104)",
                                backgroundColor: "rgb(80, 167, 104)",
                              }}
                            ></span>
                          ) : (
                            <span
                              className="el-switch__core"
                              style={{
                                width: 40,
                              }}
                            ></span>
                          )}
                        </div>
                        <small data-v-0c054ff4="" className="hint">
                          SMS оповещения
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8"
                >
                  <div
                    data-v-0c054ff4=""
                    className="el-card py16 is-always-shadow card--warning"
                  >
                    <div className="el-card__header">
                      <div data-v-0c054ff4="">
                        <i
                          data-v-0c054ff4=""
                          aria-hidden="true"
                          className="fas fa-envelope-square card__icon card__icon--small"
                        ></i>
                        <div
                          data-v-0c054ff4=""
                          className="flex align-center justify-between"
                        >
                          <small data-v-0c054ff4="">Email</small>
                          <span data-v-0c054ff4="" className="popover-editor">
                            <button
                              type="button"
                              className="el-button el-tooltip el-button--default el-button--mini is-circle el-popover__reference"
                              aria-describedby="el-popover-4390"
                              tabIndex={0}
                            >
                              <i className="el-icon-edit"></i>
                            </button>
                          </span>
                        </div>
                        <h3 data-v-0c054ff4="" className="editor-content">
                          {profile?.email ? profile?.email : "не указан"}
                        </h3>
                      </div>
                    </div>
                    <div className="el-card__body">
                      <div data-v-0c054ff4="" className="flex align-center">
                        <div
                          data-v-0c054ff4=""
                          className={classNames(
                            isCheckedEmail
                              ? "el-switch is-checked"
                              : "el-switch"
                          )}
                          onClick={checkNotificationEmail}
                        >
                          <input type="checkbox" className="el-switch__input" />
                          {isCheckedEmail ? (
                            <span
                              className="el-switch__core"
                              style={{
                                width: 40,
                                borderColor: "rgb(80, 167, 104)",
                                backgroundColor: "rgb(80, 167, 104)",
                              }}
                            ></span>
                          ) : (
                            <span
                              className="el-switch__core"
                              style={{
                                width: 40,
                              }}
                            ></span>
                          )}
                        </div>
                        <small data-v-0c054ff4="" className="hint">
                          Email оповещения
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8"
                >
                  <div
                    data-v-0c054ff4=""
                    className="el-card py16 is-always-shadow card--warning"
                  >
                    <div className="el-card__header">
                      <div data-v-0c054ff4="">
                        <i
                          data-v-0c054ff4=""
                          aria-hidden="true"
                          className="fas fa-user-tag card__icon card__icon--small"
                        ></i>
                        <div
                          data-v-0c054ff4=""
                          className="flex align-center justify-between"
                        >
                          <small data-v-0c054ff4="">ФИО</small>
                          <span data-v-0c054ff4="" className="popover-editor">
                            <button
                              type="button"
                              className="el-button el-tooltip el-button--default el-button--mini is-circle el-popover__reference"
                              aria-describedby="el-popover-563"
                              tabIndex={0}
                            >
                              <i className="el-icon-edit"></i>
                            </button>
                          </span>
                        </div>
                        <h3 data-v-0c054ff4="" className="editor-content">
                          {profile?.fullName}
                        </h3>
                      </div>
                    </div>
                    <div className="el-card__body ">
                      <div
                        data-v-0c054ff4=""
                        className="flex justify-between align-center"
                      >
                        <small
                          data-v-0c054ff4=""
                          className="hint flex"
                          style={{
                            fontSize: 16,

                            textTransform: "uppercase",
                            marginLeft: 0,
                          }}
                        >
                          Абон. плата:
                        </small>
                        <p
                          className="flex"
                          style={{
                            fontSize: 17,
                            fontWeight: 400,
                            color: "black",
                          }}
                        >
                          {profile?.paymentInMonth} ₽
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-v-0c054ff4=""
                className="profile__info mt-4 el-row el-row--flex el-card card--warning is-always-shadow gutters"
                style={{ marginLeft: 0, marginRight: 0 }}
              >
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8 align-center flex flex-column"
                  style={{ marginTop: 20 }}
                >
                  <small
                    data-v-0c054ff4=""
                    style={{ fontWeight: 400, color: "gray" }}
                  >
                    Ваш логин
                  </small>
                  <h4 data-v-0c054ff4="">{profile?.username}</h4>
                </div>
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8 align-center flex flex-column"
                  style={{ marginTop: 20 }}
                >
                  <small
                    data-v-0c054ff4=""
                    style={{ fontWeight: 400, color: "gray" }}
                  >
                    Номер лицевого счёта
                  </small>
                  <h4 data-v-0c054ff4="">{profile?.basicAccount}</h4>
                </div>
                <div
                  data-v-0c054ff4=""
                  className="el-col el-col-24 el-col-sm-12 el-col-md-8 align-center flex flex-column"
                  style={{ marginTop: 20 }}
                >
                  <small
                    data-v-0c054ff4=""
                    style={{ fontWeight: 400, color: "gray" }}
                  >
                    Ваш тариф
                  </small>
                  <h4 data-v-0c054ff4="">{profile?.tariffName}</h4>
                </div>
              </div>

              {/* BLock edit user data */}
              <div
                className="profile__info gutters el-card el-row el-row--flex card--warning is-always-shadow"
                style={{
                  marginLeft: 0,
                  marginRight: 0,
                  marginTop: 40,
                  padding: 20,
                }}
              >
                <div className="payment-online">
                  <h1 data-v-42bf1688="">Редактировать данные</h1>
                  <form
                    data-v-42bf1688=""
                    className="el-form mt-3"
                    onSubmit={editProfile}
                  >
                    <div
                      data-v-42bf1688=""
                      className="el-form-item is-required el-form-item--small"
                      style={{ maxWidth: 250 }}
                    >
                      <label className="el-form-item__label">
                        Номер телефона
                      </label>
                      <div className="el-form-item__content">
                        <div
                          data-v-42bf1688=""
                          className="el-input el-input--small el-input--suffix"
                        >
                          <input
                            type="text"
                            autoComplete="off"
                            className="el-input__inner"
                            placeholder={profile?.phone}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          />
                          <span className="el-input__suffix">
                            <span className="el-input__suffix-inner"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      data-v-42bf1688=""
                      className="el-form-item is-required el-form-item--small"
                      style={{ maxWidth: 250 }}
                    >
                      <label className="el-form-item__label">
                        Электронная почта
                      </label>
                      <div className="el-form-item__content">
                        <div
                          data-v-42bf1688=""
                          className="el-input el-input--small el-input--suffix"
                        >
                          <input
                            type="email"
                            autoComplete="off"
                            className="el-input__inner"
                            placeholder={profile?.email}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                          <span className="el-input__suffix">
                            <span className="el-input__suffix-inner"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      data-v-42bf1688=""
                      className="el-form-item is-required el-form-item--small"
                      style={{ maxWidth: 250 }}
                    >
                      <label className="el-form-item__label">
                        Новый пароль
                      </label>
                      <div className="el-form-item__content">
                        <div
                          data-v-42bf1688=""
                          className="el-input el-input--small el-input--suffix"
                        >
                          <input
                            type="password"
                            autoComplete="off"
                            className="el-input__inner"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                          <span className="el-input__suffix">
                            <span className="el-input__suffix-inner"></span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div data-v-42bf1688="" className="mb-2">
                      <small data-v-42bf1688="" className="hint ml-0">
                        Пароль должен содержать минимум 6 символов.
                      </small>
                      <small data-v-42bf1688="" className="hint ml-0">
                        После смены пароля необходимо авторизоваться заного.
                      </small>
                    </div>
                    <button
                      data-v-42bf1688=""
                      type="submit"
                      className="el-button el-button--success el-button--small "
                    >
                      <span>
                        <small data-v-42bf1688="">Изменить данные</small>
                      </span>
                    </button>
                  </form>
                </div>
              </div>
              {/* End block edit user data */}
            </div>
          </div>
        </main>
      </div>
      {notification ? (
        <Notification message={"Данные успешно обновлены"} />
      ) : null}
    </div>
  );
};

export default ProfilePage;
